import React from "react";
import { Typography } from "@mui/material";
import { getMapsUrl } from "../utils/venue";

interface VenueBadgeProps {
  venueName?: string;
  venueAddress?: string;
  variant?: "caption" | "body2" | "body1";
  color?: string;
}

// Tap-to-navigate venue indicator, shown wherever a league day/match's venue
// is displayed so players never have to guess or ask where to go.
export default function VenueBadge({
  venueName,
  venueAddress,
  variant = "caption",
  color = "text.secondary",
}: VenueBadgeProps) {
  if (!venueName) return null;

  const content = (
    <Typography variant={variant} color={color} noWrap>
      📍 {venueName}
    </Typography>
  );

  if (!venueAddress) return content;

  return (
    <a
      href={getMapsUrl(venueAddress)}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" }}
      onClick={(e) => e.stopPropagation()}
    >
      {content}
    </a>
  );
}
